/**
 * CallDirection
 * -------------
 *
 * Client-perspective direction of the current call context.
 *
 * NONE:
 *   No call direction is currently established.
 *
 * OUTGOING:
 *   The local user initiated the call.
 *
 * INCOMING:
 *   The local user is receiving the call.
 */
export const CALL_DIRECTION = {
    NONE: "NONE",
    OUTGOING: "OUTGOING",
    INCOMING: "INCOMING",
};
/**
 * CallRole
 * --------
 *
 * Client-perspective participant role within the current call context.
 *
 * NONE:
 *   No call role is currently established.
 *
 * CALLER:
 *   The local user is the caller.
 *
 * CALLEE:
 *   The local user is the callee.
 */
export const CALL_ROLE = {
    NONE: "NONE",
    CALLER: "CALLER",
    CALLEE: "CALLEE",
};
